// extracted by mini-css-extract-plugin
module.exports =  {"reportTitle":"reportTitle_ZoCs29sb","titleInput":"titleInput_Sjey2UNl"};